import { render, staticRenderFns } from "./RaWebrtcChatEnvelopeDisplay.vue?vue&type=template&id=f86a0c30&scoped=true&"
import script from "./RaWebrtcChatEnvelopeDisplay.vue?vue&type=script&lang=js&"
export * from "./RaWebrtcChatEnvelopeDisplay.vue?vue&type=script&lang=js&"
import style0 from "./RaWebrtcChatEnvelopeDisplay.vue?vue&type=style&index=0&id=f86a0c30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86a0c30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBadge,VBtn,VDivider,VImg,VList,VListItem,VListItemTitle,VSwitch})
